export default __webpack_public_path__ + "static/media/186.07075333.png";